export default {
  // Authentication pages
  auth: {
    // Common auth labels (used across forms)
    nameLabel: 'Name',
    emailLabel: 'Email address',
    passwordLabel: 'Password',
    confirmPasswordLabel: 'Confirm password',
    namePlaceholder: 'Full name',
    emailPlaceholder: 'email@example.com',
    passwordPlaceholder: 'Password',
    failed: 'These credentials do not match our records.',
    throttle: 'Too many login attempts. Please try again in :seconds seconds.',
    login: {
      title: 'Sign in to your account',
      description: 'Enter your email and password below to sign in',
      pageTitle: 'Login',
      emailLabel: 'Email address',
      emailPlaceholder: "email{'@'}example.com",
      passwordLabel: 'Password',
      passwordPlaceholder: 'Password',
      forgotPassword: 'Forgot password?',
      rememberMe: 'Remember me',
      loginButton: 'Sign in',
      noAccount: "Don't have an account?",
      signUp: "Sign up"
    },
    register: {
      title: 'Create an account',
      description: 'Enter your information below to create your account',
      pageTitle: 'Register',
      nameLabel: 'Name',
      namePlaceholder: 'Full name',
      emailLabel: 'Email address',
      emailPlaceholder: "email{'@'}example.com",
      passwordLabel: 'Password',
      passwordPlaceholder: 'Password',
      confirmPasswordLabel: 'Confirm password',
      confirmPasswordPlaceholder: 'Confirm password',
      createButton: 'Create an account',
      alreadyHaveAccount: 'Already have an account?',
      login: 'Sign in'
    },
    forgotPassword: {
      title: 'Forgot password',
      description: 'Enter your email address to receive a reset link',
      pageTitle: 'Forgot password',
      emailLabel: 'Email address',
      emailPlaceholder: "email{'@'}example.com",
      sendButton: 'Send reset link',
      backToLogin: 'Or return to',
      backToLoginLink: 'sign in'
    },
    resetPassword: {
      title: 'Reset password',
      description: 'Enter your new password',
      pageTitle: 'Reset password',
      emailLabel: 'Email address',
      passwordLabel: 'New password',
      confirmPasswordLabel: 'Confirm new password',
      resetButton: 'Reset password'
    },
    confirmPassword: {
      title: 'Confirm password',
      description: 'This is a secure area of the application. Please confirm your password before continuing.',
      pageTitle: 'Confirm password',
      passwordLabel: 'Password',
      confirmButton: 'Confirm password'
    },
    verifyEmail: {
      title: 'Verify your email',
      description: 'Please verify your email address by clicking on the link we just sent you.',
      pageTitle: 'Email verification',
      resendButton: 'Resend verification link',
      logoutButton: 'Log out'
    }
  },

  // Navigation and menus
  navigation: {
    dashboard: 'Dashboard',
    settings: 'Settings',
    logout: 'Log out',
    navigationMenu: 'Navigation menu',
    platform: 'Platform',
    administration: 'Administration',
    // Translations for future use in other branches
    repository: 'Repository',
    documentation: 'Documentation',
    githubRepo: 'Github Repo',
    externalLink: 'External link'
  },

  // Dashboard
  dashboard: {
    title: 'Dashboard',
    pageTitle: 'Dashboard',
    welcome: 'Welcome',
    admin_overview: 'Administrator overview of your application',
    user_overview: 'Your personal space and activities',
    admin_mode: 'Administrator Mode',
    user_mode: 'User Mode',
    stats: {
      total_users: 'Total Users',
      total_users_desc: 'Total number of registered users',
      active_users: 'Active Users',
      active_users_desc: 'Users connected this month',
      pending_tasks: 'Pending Tasks',
      pending_tasks_desc: 'Tasks to process',
      growth_rate: 'Growth Rate',
      growth_rate_desc: 'Growth this month'
    },
    user_stats: {
      profile_completion: 'Profile Completed',
      profile_completion_desc: 'Percentage of your profile filled',
      notifications: 'Notifications',
      notifications_desc: 'Unread notifications',
      recent_activity: 'Recent Activity',
      recent_activity_desc: 'Actions performed this month',
      tasks_completed: 'Tasks Completed',
      tasks_completed_desc: 'Tasks accomplished this week'
    },
    recent_activity: 'Recent Activity',
    my_activity: 'My Activity',
    user_logged_in: 'User logged in',
    new_user_registered: 'New user registered',
    task_completed: 'Task completed',
    profile_updated: 'Profile updated',
    password_changed: 'Password changed',
    account_created: 'Account created',
    quick_actions: 'Quick Actions',
    admin_actions: 'Administrator Actions',
    manage_users: 'Manage Users',
    view_analytics: 'View Analytics',
    system_settings: 'System Settings',
    complete_profile: 'Complete Profile',
    account_settings: 'Account Settings',
    notification_preferences: 'Notification Preferences',
    getting_started: 'Getting Started',
    getting_started_desc: 'Complete your profile and explore available features.',
    explore_features: 'Explore Features',
    user_welcome_message: 'You are successfully logged in. Explore the available features.',
    get_started: 'Get Started'
  },



  // Settings
  settings: {
    title: 'Settings',
    description: 'Manage your profile and account settings',
    navigation: {
      profile: 'Profile',
      password: 'Password',
      appearance: 'Appearance'
    },
    profile: {
      title: 'Profile information',
      pageTitle: 'Profile settings',
      breadcrumbTitle: 'Profile settings',
      description: 'Update your name and email address',
      nameLabel: 'Name',
      namePlaceholder: 'Full name',
      emailLabel: 'Email address',
      emailPlaceholder: 'Email address',
      saveButton: 'Save',
      saved: 'Saved.',
      emailUnverified: 'Your email address is unverified.',
      resendVerification: 'Click here to re-send the verification email.',
      deleteAccount: 'Delete account',
      deleteAccountDescription: 'Delete your account and all of its resources'
    },
    password: {
      title: 'Update password',
      pageTitle: 'Change password',
      breadcrumbTitle: 'Password settings',
      currentPasswordLabel: 'Current password',
      newPasswordLabel: 'New password',
      confirmPasswordLabel: 'Confirm new password',
      updateButton: 'Update password',
      description: 'Ensure your account is using a long, random password to stay secure.',
      saved: 'Saved.'
    },
    appearance: {
      title: 'Appearance settings',
      pageTitle: 'Appearance',
      breadcrumbTitle: 'Appearance settings',
      description: 'Update your account appearance settings',
      themeLabel: 'Theme',
      lightTheme: 'Light',
      darkTheme: 'Dark',
      systemTheme: 'System',
      forcedThemeDescription: 'The application exclusively uses the dark theme with a green color palette.'
    },
    deleteUser: {
      title: 'Delete account',
      description: 'Delete your account and all of its resources',
      warning: 'Warning',
      warningDescription: 'Please proceed with caution, this action cannot be undone.',
      deleteButton: 'Delete account',
      confirmTitle: 'Are you sure you want to delete your account?',
      confirmDescription: 'Once your account is deleted, all of its resources and data will be permanently deleted. Please enter your password to confirm you would like to permanently delete your account.',
      passwordLabel: 'Password',
      passwordPlaceholder: 'Password',
      cancel: 'Cancel'
    }
  },

  // Common messages
  common: {
    save: 'Save',
    cancel: 'Cancel',
    create: 'Create',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    status: 'Status',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    close: 'Close',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    warning: 'Warning',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    saving: 'Saving...',
    creating: 'Creating...',
    updating: 'Updating...',
    active: 'Active',
    inactive: 'Inactive',
    optional: 'Optional',
    required: 'Required',
    information: 'Information',
    search: 'Search',
    filters: 'Filters',
    reset: 'Reset',
    actions: 'Actions',
    refresh: 'Refresh',
    permission_denied: 'You do not have the necessary permissions',
    time: {
      now: 'Now',
      minutes_ago: '{count}m ago',
      hours_ago: '{count}h ago',
      days_ago: '{count}d ago'
    }
  },

  // Notification messages
  notifications: {
    profileUpdated: 'Profile updated successfully.',
    passwordUpdated: 'Password updated successfully.',
    emailVerificationSent: "A new verification link has been sent to your email address.",
    accountDeleted: 'Your account has been deleted.'
  },

  // Languages
  language: {
    french: 'Français',
    english: 'English',
    selectLanguage: 'Change language'
  },

  // Administration
  admin: {
    users: {
      title: 'User Management',
      description: 'Manage users and their roles',
      add_user: 'Add User',
      user_list: 'User List',
      total_users: 'Total Users',
      verified_users: 'Verified Users',
      unverified_users: 'Unverified',
      admin_users: 'Administrators',
      search_placeholder: 'Search by name or email...',
      filter_by_role: 'Filter by role',
      all_roles: 'All roles',
      all_statuses: 'All statuses',
      verified: 'Verified',
      unverified: 'Unverified',
      email_not_verified: 'Email not verified',
      resend_verification: 'Resend verification',
      showing_users: 'Showing {from} to {to} of {total} users',
      confirm_delete: 'Are you sure you want to delete {name}?',
      user_info: 'User Information',
      email_verified: 'Email Verified',
      created_at: 'Created at',
      roles_permissions: 'Roles & Permissions',
      roles_permissions_desc: 'Roles and permissions assigned to this user',
      roles: 'Roles',
      permissions: 'Permissions',
      create_description: 'Create a new user with their information and role',
      edit_description: 'Edit user information and role',
      user_details: 'User Details',
      role: 'Role',
      select_role: 'Select a role',
      create_user: 'Create User',
      edit_user: 'Edit User',
      edit_details: 'Edit Details',
      new_password: 'New Password',
      new_password_placeholder: 'Leave blank to keep current',
      password_optional: 'Leave blank to keep current password',
      edit_save_info: 'After saving, you will be redirected to the user list',
      notifications: 'Notifications',
      receive_contact_notifications: 'Receive contact requests',
      receive_contact_notifications_description: 'This user will receive an email for each new contact request submitted on the website.',
    },
    roles: {
      'super-admin': 'Super Admin',
      'admin': 'Administrator',
      'user': 'User',
      'prestataire': 'Service Provider'
    }
  },

  // Validation
  validation: {
    phone_number: 'The phone number is not valid',
    postal_code: 'The postal code is not valid',
    file_type: 'File type not allowed',
    file_size: 'File is too large (max {max}MB)',
    max_files: 'Too many files selected (max {max})'
  },

  // File upload
  upload: {
    click_to_upload: 'Click to upload',
    or_drag_and_drop: 'or drag and drop',
    max_size: 'Max size: {size}',
    file_selected: '{count} file(s) selected',
    remove_file: 'Remove file'
  },

  // Notification system
  notificationSystem: {
    title: 'Notifications',
    no_notifications: 'No notifications',
    mark_as_read: 'Mark as read',
    mark_all_read: 'Mark all as read',
    view_all: 'View all notifications',
    welcome: {
      subject: 'Welcome!',
      title: 'Welcome',
      greeting: 'Hello {name}!',
      message: 'Welcome {name}!',
      line1: 'Thank you for signing up to our platform.',
      line2: 'You can now access all features.',
      action: 'Go to dashboard',
      footer: 'Thank you for using our application!'
    }
  },

  // Events
  events: {
    title: 'Events',
    our_events: 'Our Events',
    event: 'Event',
    description: 'Discover all upcoming events at Lyra Events - Le Bar',
    no_events: 'No events found',
    no_events_message: 'No events match your search.',
    no_events_scheduled: 'No events scheduled at the moment.',
    search_placeholder: 'Search for an event...',
    reset_search: 'Reset search',
    view_details: 'View details',
    other_events: 'Other events',
    discover_next: 'Discover our upcoming events',
    see_all_events: 'See all events',
    share_event: 'Share event',
    back_to_events: 'Back to events',
    home: 'Home',
    my_account: 'My account',
    event_count: '{count} event{plural}',
    status: {
      active: 'Active event',
      inactive: 'Inactive',
      past: 'Ended',
      cancelled: 'Cancelled'
    },
    info: {
      practical_info: 'Practical information',
      schedule: 'Schedule',
      start: 'Start',
      end: 'End',
      location: 'Location',
      organized_by: 'Organized by',
      team: 'Lyra Events Team',
      date: 'Date',
      time: 'Time',
      need_info: 'Need information?'
    },
    admin: {
      management: 'Event Management',
      management_description: 'Manage all bar events',
      create: 'Create Event',
      create_description: 'Add a new event to the bar',
      edit: 'Edit Event',
      edit_description: 'Edit event information',
      new_event: 'New Event',
      back_to_list: 'Back to list',
      view_event: 'View event',
      total_events: 'Total events',
      active_events: 'Active events',
      upcoming: 'Upcoming',
      past: 'Past',
      form: {
        title: 'Event title',
        title_placeholder: 'e.g. Live Jazz Night',
        description: 'Description',
        description_placeholder: 'Describe your event...',
        start_date: 'Start date and time',
        end_date: 'End date and time',
        location: 'Location',
        location_placeholder: 'e.g. Main room, Bar, Terrace...',
        image_url: 'Image',
        image_placeholder: 'https://example.com/image.jpg',
        is_active: 'Active event (visible on public site)',
        preview: 'Preview',
        event_info: 'Event information',
        created_by: 'Created by',
        created_at: 'Created at',
        updated_at: 'Updated at',
        current_status: 'Current status'
      },
      actions: {
        create: 'Create event',
        creating: 'Creating...',
        save: 'Save',
        saving: 'Saving...',
        draft: 'Save draft',
        deactivate: 'Deactivate',
        deactivating: 'Deactivating...',
        delete: 'Delete this event',
        confirm_delete: 'Are you sure you want to permanently delete the event "{title}"?',
        delete_error: 'An error occurred while deleting.'
      }
    },
    cta: {
      join_community: 'Join our community',
      join_description: 'Create your loyalty account and enjoy exclusive benefits',
      register_free: 'Sign up for free',
      login: 'Sign in'
    },
    messages: {
      link_copied: 'Link copied to clipboard!'
    }
  },

  // Promotions
  promotions: {
    title: 'My Promotions',
    description: 'Enjoy your exclusive loyalty benefits',
    available: 'Available promotions',
    used: 'Used promotions',
    no_promotions: 'No promotions available',
    no_promotions_message: 'Come back soon to discover new exclusive offers!',
    no_used_promotions: 'No promotions used',
    no_used_promotions_message: 'Your used promotions will appear here.',
    history: 'Promotion history',
    ready_to_use: 'Ready to use',
    usage_history: 'Usage history',
    promotion_count: '{count} promotion{plural}',
    promotion_used_count: '{count} promotion{plural} used',
    valid_until: 'Valid until',
    usage_limit: 'Max {limit} use{plural} per person',
    use_now: 'Use now',
    using: 'Using...',
    used_label: 'Used',
    used_on: 'Used on',
    confirm_use: 'Are you sure you want to use the promotion "{title}"?',
    use_error: 'An error occurred while using the promotion.',
    errors: {
      already_used: 'You have already used this promotion.',
      usage_limit_reached: 'You have reached the usage limit for this promotion.',
      not_active: 'This promotion is no longer active.',
      expired: 'This promotion has expired.',
      not_available_yet: 'This promotion is not yet available.',
      unknown: 'An error occurred while using the promotion.'
    },
    how_it_works: {
      title: 'How does it work?',
      description: 'Simply enjoy your loyalty benefits',
      step1_title: 'Browse your promotions',
      step1_description: 'Discover all your available exclusive offers',
      step2_title: 'Use with one click',
      step2_description: 'Activate your promotion directly from your account',
      step3_title: 'Enjoy at the bar',
      step3_description: 'Present your confirmation to our team'
    },
    admin: {
      management: 'Promotion Management',
      management_description: 'Manage loyalty program promotions',
      create: 'Create Promotion',
      edit: 'Edit Promotion',
      new_promotion: 'New Promotion',
      new_promotion_description: 'Add a new promotion to the loyalty program',
      edit_description: 'Edit promotion information',
      back_to_list: 'Back to list',
      view_promotion: 'View promotion',
      total_promotions: 'Total promotions',
      active_promotions: 'Active promotions',
      total_usages: 'Total usages',
      expired_promotions: 'Expired promotions',
      save_draft: 'Save draft',
      create_promotion: 'Create promotion',
      update_promotion: 'Update promotion',
      form: {
        title: 'Promotion title',
        title_placeholder: 'e.g. Happy Hour - 20% off',
        description: 'Description',
        description_placeholder: 'Describe your promotion in detail...',
        type: 'Promotion type',
        select_type: 'Select a type',
        percentage_value: 'Discount percentage',
        amount_value: 'Discount amount (€)',
        valid_from: 'Start date',
        valid_until: 'End date',
        usage_limit: 'Usage limit per user',
        usage_limit_placeholder: 'Leave blank for no limit',
        usage_limit_help: 'Maximum number of uses per user (optional)',
        image_url: 'Image',
        conditions: 'Terms and conditions',
        conditions_placeholder: 'e.g. Valid weekends only, Minimum order €25...',
        is_active: 'Active promotion (visible and usable by customers)',
        preview: 'Preview'
      }
    },
    types: {
      percentage: 'Percentage discount',
      fixed_amount: 'Fixed amount discount',
      free_drink: 'Free drink'
    }
  },

  // Prestations
  prestations: {
    title: 'My Gigs',
    description: 'Manage your musical performances',
    no_prestations: 'No gigs',
    no_prestations_message: 'You don\'t have any gigs yet.',
    create_first: 'Create your first gig!',
    search_placeholder: 'Search for a gig...',
    all_statuses: 'All statuses',
    prestation_count: '{count} gig{plural}',
    admin: {
      management: 'Gigs Management',
      management_description: 'Manage gigs and notify available providers',
      new_prestation: 'New gig',
      edit_prestation: 'Edit gig',
      create_description: 'Create a new gig and notify providers',
      edit_description: 'Edit gig information',
      back_to_list: 'Back to list',
      total: 'Total',
      total_prestations: 'Gigs created',
      published: 'Published',
      published_desc: 'Awaiting responses',
      assigned: 'Assigned',
      assigned_desc: 'Provider chosen',
      completed: 'Completed',
      completed_desc: 'Completed gigs',
      list_title: 'Gigs list',
      list_description: 'Manage your gigs, notify providers and assign them',
      filter_all: 'All statuses',
      filter_draft: 'Draft',
      filter_published: 'Published',
      filter_assigned: 'Assigned',
      filter_completed: 'Completed'
    },
    status: {
      draft: 'Draft',
      published: 'Published',
      assigned: 'Assigned',
      completed: 'Completed'
    },
    fields: {
      title: 'Title',
      description: 'Description',
      event_date: 'Event date',
      event_time: 'Time',
      location: 'Location',
      price: 'Price (€)',
      duration: 'Duration (hours)',
      equipment_provided: 'Equipment provided',
      equipment_required: 'Equipment required',
      assigned_to: 'Assigned to',
      responses: 'Responses',
      no_responses: 'No responses',
      available: 'available',
      responses_count: 'response(s)'
    },
    actions: {
      create: 'Create gig',
      edit: 'Edit',
      notify: 'Notify providers',
      view_responses: 'View responses',
      assign: 'Assign',
      delete: 'Delete',
      confirm_delete: 'Are you sure you want to delete this gig?'
    },
    responses: {
      title: 'Provider responses',
      available: 'Available',
      unavailable: 'Unavailable',
      pending: 'Pending',
      no_responses: 'No responses yet',
      no_responses_desc: 'Notified providers will receive an email',
      responded_on: 'Responded on',
      assign_confirm: 'Are you sure you want to assign this gig to {name}?',
      assign_error: 'Error during assignment'
    },
    notify: {
      title: 'Notify providers',
      description: 'Select providers to notify for this gig',
      select_providers: 'Select providers',
      no_providers: 'No providers available',
      send: 'Notify',
      cancel: 'Cancel',
      success: '{count} provider(s) notified'
    }
  }
};
